import { render } from "./SidebarItemLink.vue?vue&type=template&id=384c2944&ts=true"
import script from "./SidebarItemLink.vue?vue&type=script&lang=ts"
export * from "./SidebarItemLink.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/lpoa_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__